// Theme: silk-console
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'silk-console',
  name: 'SILK CONSOLE',
  tagline: 'SILK CONSOLE',
  description: 'Cinza-azul suave com assinatura premium limpa e sem efeitos extras.',
  category: 'system-core',
  tier: 'common',
  basePrice: 1575,
  swatches: ['#2F3A4A', '#3A4A5A', '#A8C4D8', '#F6F8FA'],
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '8px',
      '--shadow-card': '0 8px 20px rgba(0, 0, 0, 0.20)',
      '--shadow-card-active': '0 10px 24px color-mix(in srgb, var(--primary) 35%, transparent)'
    },
    shellClasses: 'font-mono theme-silk-console'
  },
  colorVars: {
    '--accent': '#A8C4D8',
    '--accent-foreground': '#2F3A4A',
    '--background': '#2F3A4A',
    '--border': '#5A7A8F',
    '--card': '#3A4A5A',
    '--card-border-active': 'rgba(168, 196, 216, 0.35)',
    '--card-completed': '#31404E',
    '--card-foreground': '#F6F8FA',
    '--card-glow': 'rgba(168, 196, 216, 0.08)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#0a0a0a',
    '--foreground': '#F6F8FA',
    '--hold-fill': '#A8C4D8',
    '--input': '#5A7A8F',
    '--modal-bg': '#2F3A4A',
    '--modal-border': '#5A7A8F',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 8px 20px rgba(0, 0, 0, 0.20)',
    '--muted': '#5A7A8F',
    '--muted-foreground': '#F6F8FA',
    '--nav-active': '#A8C4D8',
    '--nav-bg': '#3A4A5A',
    '--popover': '#3A4A5A',
    '--popover-foreground': '#F6F8FA',
    '--primary': '#A8C4D8',
    '--primary-foreground': '#2F3A4A',
    '--ring': '#A8C4D8',
    '--secondary': '#5A7A8F',
    '--secondary-foreground': '#F6F8FA',
    '--streak': '#A8C4D8',
    '--success': '#22c55e',
    '--success-foreground': '#2F3A4A',
    '--xp': '#A8C4D8',
    '--xp-bg': '#3A4A5A'
  },
  resolvedVars: {
    '--accent': '#A8C4D8',
    '--accent-foreground': '#2F3A4A',
    '--accent-foreground-hsl': '216 22% 24%',
    '--accent-foreground-oklch': 'from #2F3A4A l c h',
    '--accent-hsl': '205 38% 75%',
    '--accent-oklch': 'from #A8C4D8 l c h',
    '--background': '#2F3A4A',
    '--background-hsl': '216 22% 24%',
    '--background-oklch': 'from #2F3A4A l c h',
    '--border': '#5A7A8F',
    '--border-hsl': '204 23% 46%',
    '--border-oklch': 'from #5A7A8F l c h',
    '--border-w': '1px',
    '--card': '#3A4A5A',
    '--card-border-active': 'rgba(168, 196, 216, 0.35)',
    '--card-completed': '#31404E',
    '--card-completed-hsl': '209 23% 25%',
    '--card-completed-oklch': 'from #31404E l c h',
    '--card-foreground': '#F6F8FA',
    '--card-foreground-hsl': '210 29% 97%',
    '--card-foreground-oklch': 'from #F6F8FA l c h',
    '--card-glow': 'rgba(168, 196, 216, 0.08)',
    '--card-hsl': '210 22% 29%',
    '--card-oklch': 'from #3A4A5A l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#0a0a0a',
    '--destructive-foreground-hsl': '0 0% 4%',
    '--destructive-foreground-oklch': 'from #0a0a0a l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #ef4444 l c h',
    '--foreground': '#F6F8FA',
    '--foreground-hsl': '210 29% 97%',
    '--foreground-oklch': 'from #F6F8FA l c h',
    '--hold-fill': '#A8C4D8',
    '--hold-fill-hsl': '205 38% 75%',
    '--hold-fill-oklch': 'from #A8C4D8 l c h',
    '--input': '#5A7A8F',
    '--input-hsl': '204 23% 46%',
    '--input-oklch': 'from #5A7A8F l c h',
    '--modal-bg': '#2F3A4A',
    '--modal-bg-hsl': '216 22% 24%',
    '--modal-bg-oklch': 'from #2F3A4A l c h',
    '--modal-border': '#5A7A8F',
    '--modal-border-hsl': '204 23% 46%',
    '--modal-border-oklch': 'from #5A7A8F l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 8px 20px rgba(0, 0, 0, 0.20)',
    '--muted': '#5A7A8F',
    '--muted-foreground': '#F6F8FA',
    '--muted-foreground-hsl': '210 29% 97%',
    '--muted-foreground-oklch': 'from #F6F8FA l c h',
    '--muted-hsl': '204 23% 46%',
    '--muted-oklch': 'from #5A7A8F l c h',
    '--nav-active': '#A8C4D8',
    '--nav-active-hsl': '205 38% 75%',
    '--nav-active-oklch': 'from #A8C4D8 l c h',
    '--nav-bg': '#3A4A5A',
    '--nav-bg-hsl': '210 22% 29%',
    '--nav-bg-oklch': 'from #3A4A5A l c h',
    '--popover': '#3A4A5A',
    '--popover-foreground': '#F6F8FA',
    '--popover-foreground-hsl': '210 29% 97%',
    '--popover-foreground-oklch': 'from #F6F8FA l c h',
    '--popover-hsl': '210 22% 29%',
    '--popover-oklch': 'from #3A4A5A l c h',
    '--primary': '#A8C4D8',
    '--primary-foreground': '#2F3A4A',
    '--primary-foreground-hsl': '216 22% 24%',
    '--primary-foreground-oklch': 'from #2F3A4A l c h',
    '--primary-hsl': '205 38% 75%',
    '--primary-oklch': 'from #A8C4D8 l c h',
    '--radius': '8px',
    '--ring': '#A8C4D8',
    '--ring-hsl': '205 38% 75%',
    '--ring-oklch': 'from #A8C4D8 l c h',
    '--secondary': '#5A7A8F',
    '--secondary-foreground': '#F6F8FA',
    '--secondary-foreground-hsl': '210 29% 97%',
    '--secondary-foreground-oklch': 'from #F6F8FA l c h',
    '--secondary-hsl': '204 23% 46%',
    '--secondary-oklch': 'from #5A7A8F l c h',
    '--shadow-card': '0 8px 20px rgba(0, 0, 0, 0.20)',
    '--shadow-card-active': '0 10px 24px color-mix(in srgb, var(--primary) 35%, transparent)',
    '--streak': '#A8C4D8',
    '--streak-hsl': '205 38% 75%',
    '--streak-oklch': 'from #A8C4D8 l c h',
    '--success': '#22c55e',
    '--success-foreground': '#2F3A4A',
    '--success-foreground-hsl': '216 22% 24%',
    '--success-foreground-oklch': 'from #2F3A4A l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22c55e l c h',
    '--tint-primary-subtle': 'hsla(205 38% 75% / 0.15)',
    '--xp': '#A8C4D8',
    '--xp-bg': '#3A4A5A',
    '--xp-bg-hsl': '210 22% 29%',
    '--xp-bg-oklch': 'from #3A4A5A l c h',
    '--xp-hsl': '205 38% 75%',
    '--xp-oklch': 'from #A8C4D8 l c h'
  }
}
